import { useGetMe } from '@/lib/api/me.ts';
import PsiInvestmentsList from '../../features/investments/list/PsiInvestmentsList.tsx';
import InvestorInvestmentsList from '@/features/investments/list/investor/InvestorInvestmentsList.tsx';

const InvestmentsPage = () => {
  const { data: user } = useGetMe();

  if (!user) {
    return <div>Cargando...</div>;
  }

  if (user.role === 'psi') {
    return <PsiInvestmentsList />;
  }

  return <InvestorInvestmentsList />;
};

export default InvestmentsPage;
